import React from 'react';
import { withRouter } from "react-router-dom";
import { logUI } from '../../api/andyliticsApi';
import { isCentralTimeZone, getCurDateInCentralTz, getCentralDateWithFormat, getURLPath } from "../../helpers/Tools";
import MiniSpinner from "../common/MiniSpinner";
import moment from 'moment';


class VideoVisitAvailability extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { type } = this.props;
        logUI(`MBHWeb.UI.VideoVisitAvailability.${type === "FINDNEWDOCTOR" ? "FindNewDoctor" : type === "ONCALLPROVIDER" ? "OnCallProvider" : "YourDoctor"}.ComponentDidMount`, new Date(), getURLPath());
    }

    scheduleAppointment(e, item, isMoreButton=false) {
        const { type, isFromVideoVisitOptions } = this.props;
        logUI(`MBHWeb.UI.VideoVisitAvailability.${type === "FINDNEWDOCTOR" ? "FindNewDoctor" : type === "ONCALLPROVIDER" ? "OnCallProvider" : "YourDoctor"}.OnButtonClick`, new Date(), getURLPath(), JSON.stringify(item));

        if (type === "YOURDOCTOR") 
            this.props.history.push({
                pathname: isMoreButton ? item.moreUrl : item.redirectTo,
                state: { selectedUser: this.props.selectedUser, noSelectPatient: this.props.noSelectPatient, scheduleType: "DirectSchedule", isFromVideoVisitOptions: isFromVideoVisitOptions } 
            });

        if ( type === "FINDNEWDOCTOR")
            this.props.history.push({
                pathname: isMoreButton ? item.moreUrl : item.redirectTo,
                state: { selectedUser: this.props.selectedUser, noSelectPatient: this.props.noSelectPatient, isFromVideoVisitOptions: isFromVideoVisitOptions }
            });
        
        if (type === "ONCALLPROVIDER") 
            this.props.history.push({
                pathname: item.redirectTo,
                state: { selectedTimeSlot: item.timeSlot, selectedDay: item.selectedDay, isFromVideoVisitOptions: isFromVideoVisitOptions }
            });
        
    }

    render() {
        const { type, data, displayName, specialty, avatar, disabled, error, errorMsg, showMiniSpinner, hasMoreButton, showTimeZoneMessage } = this.props;
        const provPhoto = avatar ? avatar : '/images/profile-pic.png';
        const buttons = data && data.length > 0 && !error && data.map((item, key) => {
            const time = item.time;
            const day = item.day;
            const timezone = showTimeZoneMessage && !isCentralTimeZone() ? getCentralDateWithFormat(new Date(), "z") : "";
            const displaytime = `${time} ${timezone}`;//: time;
            
            return (<button className="btn btn-primary" disabled={disabled} key={key + displayName} onClick={(e) => { this.scheduleAppointment(e, item); }}>{displaytime}  |  {day}</button>);
        });

        if (hasMoreButton && buttons)
            buttons.push(<button className="btn btn-primary" onClick={(e) => { this.scheduleAppointment(e, data[0], hasMoreButton); }}  key={type+"_morebtn"}>MORE</button>); 

        return (<div className="col-12">
            <div className="row videovisit-schedule-container">
                <div className="col-12">
                    <h4>Next available times</h4>
                </div>
                {showMiniSpinner 
                    ? <div className="col-12 align-self-center"><MiniSpinner /></div>
                    : <React.Fragment>
                        {data && data.length > 0 && !error 
                            ? <React.Fragment>
                                <div className="col-12">
                                    <div className="videovisit-schedule-provider">
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="item-avatar-container">
                                                    <div className="item-img-container" style={{ backgroundImage: `url(${provPhoto})` }}>
                                                        <div className="item-img" />
                                                    </div>
                                                </div>
                                                <div className="item-details">
                                                    <div className="row">
                                                        <div className="col-12 item-name">
                                                            {displayName}<br />
                                                            {specialty && <span className="item-specialty">{specialty}</span>}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12 videovisit-schedule-availability-btns" key={displayName}>
                                    {buttons}
                                </div>
                            </React.Fragment>
                            : <div className="col-12 no-times-available">
                                {errorMsg
                                    ? errorMsg
                                    : "Sorry, we're currently not able to display times."
                                }
                            </div>
                        }
                    </React.Fragment>
                }
            </div>
        </div>);
    }

}

export default withRouter(VideoVisitAvailability);